import { FixMeLater } from '../../temporary-types';
import { ILanguageTranslation } from './globalConfigReducer';
import ACTIONS_TYPES from '../../constants/types';
import { FORM_FIELD_TYPE_CODE } from '../../constants/formElements';

interface IRegistrationFormElementPropertiesValue {
  key: string;
  value: ILanguageTranslation;
}
interface IRegistrationFormElementProperties {
  description?: ILanguageTranslation;
  errorMessageRequired?: ILanguageTranslation;
  acceptedFileExtensions?: string[];
  label?: ILanguageTranslation;
  values?: IRegistrationFormElementPropertiesValue[];
  maxLength?: number;
  minLength?: number;
  defaultValue?: any;
  notEarlierThan?: string;
  notLaterThan?: string;
  requiredValue?: any;
  hint?: ILanguageTranslation;
  isFiscalCode?: boolean;
  errorMessageFiscalCode?: ILanguageTranslation;
}
export interface IRegistrationFormElement {
  typeCode: FORM_FIELD_TYPE_CODE;
  fieldCode: string;
  required: boolean;
  isCustomField: boolean;
  properties: IRegistrationFormElementProperties | null;
}
export interface IRegistrationFormSection {
  title: ILanguageTranslation;
  elements: IRegistrationFormElement[];
}

export interface IRegistrationFormStep {
  title: Dict<string>;
  sections: IRegistrationFormSection[];
}

export interface ITelephoneNumberFormat {
  name: string;
  dialCode: string;
  countryCode: string;
  format: string;
  digitsAmount: number;
}

export interface IFormConfigState {
  currentStep: number;
  registerData: Dict<string>[];
  telephoneNumberFormat: Dict<ITelephoneNumberFormat>;
  isRedirectFromSummary: boolean;
  disableSubmit: boolean;
  acceptedSteps: number[];
  steps: IRegistrationFormStep[];
  customFields: string[];
  selectedCountry: string | undefined;
  validationResponse:IValidationResponse | null;

}


export interface IValidationResponse {
  "defaultLanguage": string,
  "startTimeValidationFailed": boolean,
  "endTimeValidationFailed": boolean,
  "startDate": string,
  "endDate": string,
  "startTime": string,
  "endTime":string,
  "timeZone": string

}

const initialState: IFormConfigState = {
  currentStep: 0,
  registerData: [],
  telephoneNumberFormat: {},
  isRedirectFromSummary: false,
  disableSubmit: false,
  acceptedSteps: [],
  steps: [],
  customFields: [],
  selectedCountry: undefined,
  validationResponse: null,
};

export default function (state = initialState, action: FixMeLater) {
  switch (action.type) {
    case ACTIONS_TYPES.SET_FORM_CONFIG:
      return { ...state, ...action.payload };

    case ACTIONS_TYPES.SET_FORM_NEXT_STEP:
      return { ...state, currentStep: state.currentStep + 1 };

    case ACTIONS_TYPES.SET_FORM_PREV_STEP:
      return { ...state, currentStep: state.currentStep - 1 };

    case ACTIONS_TYPES.SET_REGISTER_DATA: {
      const { data, step } = action.payload;
      const newRegisterData = [...state.registerData];
      newRegisterData[step] = data;
      return { ...state, registerData: newRegisterData };
    }

    case ACTIONS_TYPES.SET_TELEPHONE_NUMBER_FORMAT: {
      const { currentCountry, name } = action.payload;
      return {
        ...state,
        telephoneNumberFormat: { ...state.telephoneNumberFormat, [name]: currentCountry },
      };
    }

    case ACTIONS_TYPES.SET_FORM_STEP: {
      const { step } = action.payload;
      return { ...state, currentStep: step };
    }

    case ACTIONS_TYPES.SET_BACK_FROM_SUMMARY_STEP:
      return { ...state, isRedirectFromSummary: action.payload };

    case ACTIONS_TYPES.SET_ACCEPTED_STEPS: {
      const { step, isAccepted } = action.payload;
      const newAcceptedSteps = [...state.acceptedSteps];
      newAcceptedSteps[step] = isAccepted;
      return {
        ...state,
        acceptedSteps: newAcceptedSteps,
      };
    }

    case ACTIONS_TYPES.SET_DISABLE_SUBMIT:
      return { ...state, disableSubmit: action.payload };

    case ACTIONS_TYPES.RESET_REGISTER_DATA:
      return { ...state, registerData: [] };

    case ACTIONS_TYPES.RESET_ACCEPTED_STEPS:
      return { ...state, acceptedSteps: [] };

    case ACTIONS_TYPES.SET_CUSTOM_FIELDS: {
      return {
        ...state,
        customFields: action.payload,
      };
    }
    case ACTIONS_TYPES.SET_SELECTED_COUNTRY:
      return { ...state, selectedCountry: action.payload };

    default:
      return state;
  }
}
